import React, { Component } from 'react';
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import BackgroundColorMobile from "../components/BackgroundColorMobile/BackgroundColorMobile";
import ContactUsForm from "../components/ContactUsForm/ContactUsForm";
import ContactCargoSalesManagerForm from "../components/ContactCargoSalesManagerForm/ContactCargoSalesManagerForm";
import ContactFAQ from "../components/ContactFAQs/ContactFAQs"
import store from "../store";
import {Helmet} from "react-helmet";


class Contact extends Component {

    state = {
            activeTab: 'CONTACT_US',
            categories: '',
            hoursOfOperation: {
                dailyHoursOfOperation: []
            }
    }

    componentDidMount() {
        this.setdailyHoursofOperation ();
        this.fetchData();
    }

    fetchData = async () => {
        try {
            const response = await fetch('./content/learn/page-components/faq/faq.json');
            this.json = await response.json();

            if (response.ok) {
                this.setState({categories: this.json})
            } else {
                this.setState({
                    categories: ['Please Check Back At a Latter Date For FAQs.']
                });
            }
        } catch (e) {
            this.setState({
                categories: ['Please Check Back At a Latter Date For FAQs.']
            });
        }
    };

    setdailyHoursofOperation = async () => {
        try {
            const response = await fetch("./content/global/contact/dailyOperatingHours.json");
            if (response.ok) {
                this.setState({
                    hoursOfOperation: await response.json()
                });
            } else {
                console.log("error");
                throw response;
            }
        } catch (e) {
            console.log(e);
        }
    };

    setActiveTab = (tab) => {
        this.setState({
            activeTab: tab
        })
    };

    getActiveTab() {
        switch (this.state.activeTab) {
            case 'CONTACT_US':
                return <ContactUsForm/>;
            case 'CONTACT_CARGO_SALES_MANAGER':
                return <ContactCargoSalesManagerForm/>;
            case 'CONTACT_FAQ':
                return <ContactFAQ
                    categories = {this.state.categories}/>;

            default:
                return <ContactUsForm/>;
        }
    }

    render() {
        return (
                <div className="wrapper">
                    <Helmet>
                        {
                            store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                                return row.rowTitle === "Contact" ? row.sections.map((section) => {
                                    return section.title === "Contact" ? <meta name="description" content={section.content['seo-description']}/> : null
                                }) : null
                            }) : null
                        }
                    </Helmet>
                    <Breadcrumbs />
                    <h1 className="contact-us-title">Contact</h1>
                    <div className="contact-section">
                        <div className="contact-section__tabs">
                            <div className="contact-section__header">
                                <button className={"contact-section__tab" + (this.state.activeTab === 'CONTACT_US'  ? ' contact-section__tab--active' : '')} onClick={() => {this.setActiveTab('CONTACT_US')}}>Contact Us</button>
                                <button className={"contact-section__tab" + (this.state.activeTab === 'CONTACT_CARGO_SALES_MANAGER' ? ' contact-section__tab--active' : '')} onClick={() => {this.setActiveTab('CONTACT_CARGO_SALES_MANAGER')}}>Contact your Southwest Cargo Manager</button>
                                <button className={"contact-section__tab" + (this.state.activeTab === 'CONTACT_FAQ' ? ' contact-section__tab--active' : '')} onClick={() => {
                                    this.setActiveTab('CONTACT_FAQ');
                                }}>FAQs</button>
                            </div>
                            {this.getActiveTab()}
                        </div>
                        <div className="contact-section__info">
                            <div className="contact-section__info-block">
                                <h2 className="contact-section__info-block-title contact-section__info-block-title--phone mbl mts">Call</h2>
                                <p className="contact-section__info-block-subtitle">Cargo Customer Care</p>
                                <p>For general Cargo questions including tracking, rates, or how to open a Southwest Cargo® Account, please contact Cargo Customer Care.</p>
                                <div>
                                    <table className="mtm">
                                        <tbody>
                                        {
                                            this.state.hoursOfOperation.dailyHoursOfOperation.map( (dailyoperatinghours, index) => {
                                                return (
                                                        <tr key={index}>
                                                            <td className="table__body--holiday table__body--holiday-name">
                                                                {dailyoperatinghours.day}
                                                            </td>
                                                            <td className="table__body--holiday">
                                                                {dailyoperatinghours.openingTime}
                                                            </td>
                                                            <td className="table__body--holiday">
                                                                {dailyoperatinghours.closingTime}
                                                            </td>
                                                        </tr>
                                                )
                                            })
                                        }
                                        </tbody>
                                    </table>
                                    <table className="mtm">
                                        <tr>
                                            <td className="contact-section__info-block-text">Domestic</td>
                                            <td className="contact-section__info-block-text contact-section__info-block-text--dark-blue contact-section__info-block-text--spaced">1 (800) 533-1222</td>
                                        </tr>
                                        <tr>
                                            <td className="contact-section__info-block-text">International</td>
                                            <td className="contact-section__info-block-text contact-section__info-block-text--dark-blue contact-section__info-block-text--spaced">1 (214) 792-4881</td>
                                        </tr>
                                    </table>
                                </div>
                                <p className="contact-section__info-block-subtitle mtl">With Heart</p>
                                <p>For the transportation of human remains.</p>
                                <table className="mtm">
                                    <tbody>
                                    <tr>
                                        <td className="contact-section__info-block-text">Domestic</td>
                                        <td className="contact-section__info-block-text contact-section__info-block-text--dark-blue contact-section__info-block-text--spaced">1 (888) 922-9525</td>
                                    </tr>
                                    <tr>
                                        <td className="contact-section__info-block-text">International</td>
                                        <td className="contact-section__info-block-text contact-section__info-block-text--dark-blue contact-section__info-block-text--spaced">1 (214) 792-1333</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="contact-section__info-block">
                                <h2 className="contact-section__info-block-title contact-section__info-block-title--mail mbl">Mail</h2>
                                <p className="contact-section__info-block-subtitle">Southwest Airlines Co. Cargo Management Group</p>
                                <p className="contact-section__info-block-text">2195 Research Row</p>
                                <p className="contact-section__info-block-text mtn">Dallas, TX 75235</p>
                            </div>
                            <div className="contact-section__info-block">
                                <h2 className="contact-section__info-block-title contact-section__info-block-title--fax mbl">Fax</h2>
                                <p className="contact-section__info-block-text contact-section__info-block-text--dark-blue">1 (469) 603-6875</p>
                            </div>
                        </div>
                    </div>
                    <BackgroundColorMobile/>
                </div>
        );
    }
}

export default Contact;





// WEBPACK FOOTER //
// ./src/pages/Contact.js